import Hero from "@/components/landing/Hero";
import ConnectiveLayer from "@/components/landing/ConnectiveLayer";
import ContinuousLoop from "@/components/landing/ContinuousLoop";
import ParadigmShift from "@/components/landing/ParadigmShift";
import MaturityTimeline from "@/components/landing/MaturityTimeline";
import Footer from "@/components/landing/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="bg-cream text-navy">
      <Hero />
      <ConnectiveLayer />
      <ContinuousLoop />
      <ParadigmShift />
      <MaturityTimeline />
      <Footer />
    </main>
  );
}
